const categories = [
  {
    image: "images/headphone.jpg",
    name: "Headpones",
    quantity: "10",
  },
  {
    image: "images/laptop.jpg",
    name: "Electronics",
    quantity: "20",
  },
  {
    image: "images/speaker.jpg",
    name: "Audio",
    quantity: "30",
  },
  {
    image: "images/tv.jpg",
    name: "TVs",
    quantity: "40",
  },
  {
    image: "images/watch.jpg",
    name: "Watches",
    quantity: "50",
  },
];

export default categories;
